export default __webpack_public_path__ + "static/media/gift.211032ae.png";